import { Box } from '@chakra-ui/react'
import { AnimateSharedLayout } from 'framer-motion'

import { Notifications } from '@/features/notification'
import { ProductMessageBanner } from '@/features/product-messages'
import { MicPermissionBanner } from '@/features/system-banners'

interface AppLayoutIProps {
  children?: React.ReactNode
}

export const AppLayout = ({ children }: AppLayoutIProps) => {
  return (
    <Box display='flex' flexDirection='column' h='100vh'>
      <Notifications />
      <ProductMessageBanner />
      <MicPermissionBanner />
      <Box flex={1} minH={0}>
        <AnimateSharedLayout>{children}</AnimateSharedLayout>
      </Box>
    </Box>
  )
}
